import React from 'react'
import { StackActions } from '@react-navigation/native'

export const navigationRef = React.createRef()

export const reset = (name, params) => {
  navigationRef.current?.reset({
    index: 0,
    routes: [{
      name,
      params,
    }],
  })
}
export const resetWithMultipleRoutes = (routes, index) => {
  navigationRef.current?.reset({
    index,
    routes,
  })
}

export const navigate = (name, params) => {
  navigationRef.current?.dispatch(StackActions.push(name, params))
}

export const goBack = () => {
  navigationRef.current.dispatch(StackActions.pop())
}
export const goBackCount = (numberOfScreens) => {
  navigationRef.current.dispatch(StackActions.pop(numberOfScreens))
}

export function getCurrentRoute() {
  return navigationRef?.current?.state?.routeName || navigationRef.current?.getCurrentRoute()?.name
}

export function isRoot() {
  const navState = navigationRef.current.getState()
  return navState.index === 0 || navState.routes.length === 1
}
